export default __webpack_public_path__ + "static/media/Interregular.bfeb3e41.woff2";